<script>
import { Event } from '@/api'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Title',
              modelPath: [this, 'form', 'title'],
              multilingual: true
            }),
            new fields.ColorSelect({
              label: 'Kolor (domyślnie Podstawowy)',
              modelPath: [this, 'form', 'color']
            }),

            new fields.ForeignKey({
              label: 'Wydarzenie',
              modelPath: [this, 'form', 'event'],
              clearable: true,
              required: true,
              paginated: false,
              labelField: 'title_pl',
              service: Event
            })
          ]
        }
      ]
    }
  }
}
</script>
